module.exports = __webpack_public_path__ + "static/media/question-mark.94f6e907.svg";